<template>
  <div class="app-container">
    <div class="screeBox">
      <el-input
        style="margin-right: 10px; width: 200px"
        v-model="screen.like"
        placeholder="税号，抬头名称，订单号"
      ></el-input>
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        @click="(screen.page = 1), fetchData()"
        style="margin-bottom: 5px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px"
        >重置</el-button
      >
    </div>
    <div style="margin-top: 20px">
      <el-button
        size="medium"
        type="danger"
        @click="delInvoice('batch')"
        style="margin-bottom: 5px"
        v-if="roles.includes('/invoice/del')"
        >删除</el-button
      >
    </div>
    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="所属园区" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="开票订单号" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.order_no }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开票时间" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.handle_time }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="抬头类型">
        <template slot-scope="scope">
          <span>{{ scope.row.head_type == 1 ? "个人" : "企业" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="抬头名称" width="120">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.head_name }}</div>
        </template>
      </el-table-column>
      <el-table-column label="发票编号" width="200">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.invoice_no }}</div>
        </template>
      </el-table-column>
      <el-table-column label="发票内容" width="200">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.content }}</div>
        </template>
      </el-table-column>
      <el-table-column label="开票金额" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.money }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="开票地址" width="200">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.url }}</div>
        </template>
      </el-table-column> -->
      <el-table-column label="驳回原因" width="120">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.reason }}</div>
        </template>
      </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">
          <span>{{ scope.row.type == 1 ? "增值税普通发票" : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="审核状态" width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.apply_status == '2'
                ? 'success'
                : scope.row.apply_status == '1'
                ? 'info'
                : 'danger'
            "
            disable-transitions
            >{{
              scope.row.apply_status == 2
                ? "审核通过"
                : scope.row.apply_status == 1
                ? "待审核"
                : "驳回"
            }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="开票状态" width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.status == '2'
                ? 'success'
                : scope.row.status == '1'
                ? 'info'
                : 'danger'
            "
            disable-transitions
            >{{
              scope.row.status == 2
                ? "已开票"
                : scope.row.status == 1
                ? "开票中"
                : "开票失败"
            }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="250" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="examine(scope.row.id)"
            v-if="roles.includes('/invoice/audit') && scope.row.status == 1"
            >审批</el-button
          >
          <el-button
            size="mini"
            type="warning"
            @click="handleInfo(scope.row.id)"
            v-if="roles.includes('/invoice/info')"
            >详情</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="delInvoice('single', scope.row.id)"
            v-if="roles.includes('/invoice/del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-dialog title="开票审批" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item
          label="审核"
          prop="flag"
          :rules="[
            { required: true, message: '请选择审核', trigger: 'change' },
          ]"
        >
          <el-radio-group v-model="form.flag">
            <el-radio label="pass">通过</el-radio>
            <el-radio label="refuse">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item prop="url" label="上传发票" v-if="form.status == 2">
          <el-upload
            ref="upload"
            class="upload-demo"
            :action="ossUpload"
            :headers="{ token: token }"
            name="file[]"
            :data="{ type: 'image' }"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item> -->
        <!-- <el-form-item prop="remark" label="备注" v-if="form.flag == 'pass'">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item> -->
        <el-form-item
          prop="remark"
          label="驳回原因"
          v-if="form.flag == 'refuse'"
        >
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-drawer
      size="860px"
      title="详情"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="infoForm"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="所属园区" prop="park_id">
          <el-select
            filterable
            v-model="infoForm.park_id"
            placeholder="请选择园区"
            disabled
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="申请人" prop="title">
          <el-input
            class="w4"
            disabled
            v-model="infoForm.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="发票类型" prop="type">
          <el-radio-group v-model="infoForm.type" disabled>
            <el-radio :label="1">增值税普通发票</el-radio>
            <!-- <el-radio :label="2">禁用</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="抬头类型" prop="head_type">
          <el-radio-group v-model="infoForm.head_type" disabled>
            <el-radio :label="1">个人</el-radio>
            <el-radio :label="2">企业</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="抬头名称" prop="head_name">
          <el-input class="w4" disabled v-model="infoForm.head_name"></el-input>
        </el-form-item>

        <el-form-item label="金额">
          <el-input
            class="w4"
            disabled
            v-model="infoForm.money"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="发票内容" prop="content">
          <el-input
            class="w4"
            disabled
            v-model="infoForm.content"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <div v-if="infoForm.head_type == 1">
          <el-form-item label="收件人姓名" prop="user_name">
            <el-input
              class="w4"
              disabled
              v-model="infoForm.user_name"
              placeholder="请输入收件人姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="收件人手机号" prop="mobile">
            <el-input
              maxlength="11"
              class="w4"
              disabled
              v-model="infoForm.mobile"
              placeholder="请输入收件人手机号"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="infoForm.head_type == 2">
          <el-form-item label="税号">
            <el-input
              class="w4"
              disabled
              v-model="infoForm.duty_number"
            ></el-input>
          </el-form-item>
          <el-form-item label="单位地址" prop="content">
            <el-input
              class="w4"
              disabled
              v-model="infoForm.address"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="单位电话" prop="content">
            <el-input
              class="w4"
              disabled
              v-model="infoForm.company_mobile"
              placeholder="请输入标题"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <el-form-item label="开户银行" prop="content">
            <el-input
              class="w4"
              disabled
              v-model="infoForm.bank_name"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="银行账户" prop="content">
            <el-input
              class="w4"
              disabled
              v-model="infoForm.bank_card"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item label="电子发票" prop="title">
          <p v-if="infoForm.img_url">
            <el-image
              :src="infoForm.img_url"
              class="tableIcon"
              fit="contain"
              :preview-src-list="infoForm.img_url.split(',')"
            >
            </el-image>
          </p>
        </el-form-item>
        <el-form-item label="开票时间：" prop="area">
          <el-input class="w4" disabled v-model="infoForm.make_time"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="infoForm.status" disabled>
            <el-radio :label="1">已申请</el-radio>
            <el-radio :label="2">已开票</el-radio>
            <el-radio :label="3">开票失败</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="接收邮箱" prop="head_name">
          <el-input class="w4" disabled v-model="infoForm.email"></el-input>
        </el-form-item>
        <el-form-item label="订单列表">
          <el-table v-if="orderLists" :data="orderLists" style="width: 100%">
            <el-table-column label="订单类型" width="100px">
              <template slot-scope="scope">
                <span>{{
                  scope.row.order_info ?formatType(scope.row.order_info.type) : ""
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="订单编号">
              <template slot-scope="scope">
                <span>{{
                  scope.row.order_detail ? scope.row.order_detail.order_num : ""
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="实收费用" width="120px">
              <template slot-scope="scope">
                <span>{{
                  scope.row.order_detail ? scope.row.order_detail.price : ""
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="创建时间">
              <template slot-scope="scope">
                <span>{{
                  scope.row.order_detail ? scope.row.order_detail.pay_time : ""
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="drawer = false"> 关闭 </el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { openPark, delImage } from "@/api/index";
import { invoiceList, info, examine, invoiceDel } from "@/api/invoice";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      infoForm: {},
      token: getToken(),
      list: [],
      listLoading: true,
      statusList: [
        {
          title: "通过",
          id: 1,
        },
        {
          title: "已驳回",
          id: 2,
        },
        {
          title: "待审核",
          id: 0,
        },
      ],
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        like: "",
      },
      total: 0,
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      dialogVisible: false,
      form: {
        id: "",
        status: "",
        reason: "",
        url: "",
      },
      rules: {
        status: [{ required: true, message: "请选择审核", trigger: "change" }],
        remark: [{ required: true, message: "请输入备注", trigger: "blur" }],
        reason: [
          { required: true, message: "请输入驳回意见", trigger: "blur" },
        ],
      },
      drawer: false,
      fileList: [],
      orderLists: [],
      multipleSelection: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    formatType(key) {
      var types = [
        "",
        "停车费",
        "水费",
        "电费",
        "物业费",
        "租赁费",
        "钓台费",
        "",
        "工位费",
        "会议室费",
      ];
      return types[key]
    },
    delInvoice(type, id) {
      var that = this;
      var ids = [];
      if (type == "single") {
        ids.push(id);
      } else {
        if (this.multipleSelection.length) {
          this.multipleSelection.forEach((item, index) => {
            ids.push(item.id);
          });
        } else {
          this.$message.error("至少选择一个");
          return;
        }
      }
      this.$confirm("确认删除？")
        .then(() => {
          invoiceDel({ id: ids.toString(",") }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delImg(path) {
      delImage({ file: path }).then((ress) => {});
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        if (this.form.url) {
          this.delImg(this.form.url);
        }
        this.form.url = res.data.url;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    handleRemove(file, fileList) {},
    handlePreview(file) {},
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 查看
    handleInfo(id) {
      var that = this;
      info({ id: id }).then((res) => {
        that.infoForm = res.data.info;
        that.orderLists = res.data.info.order_lists;
      });

      this.drawer = true;
    },
    examine(id) {
      this.form = {
        invoice_id: id,
        flag: "pass",
        remark: "",
      };
      this.dialogVisible = true;
    },
    reset() {
      this.screen = {
        park_id: "",
        page: 1,
        page_size: 15,
        like: "",
        status: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading",
          });
          examine(that.form).then((res) => {
            loading.close();
            that.dialogVisible = false;
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.fetchData();
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });
          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      invoiceList(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 100px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
</style>
